export const apiKeyValidator = key => {
  return !!key.trim();
};